const genders = [
  { name: "Choose Gender", value: 0 },
  { name: "Male", value: 1 },
  { name: "Female", value: 2 },
  { name: "Other", value: 3 },
];

const titles = [
  { name: "Title", value: 0 },
  { name: "Mr.", value: 1 },
  { name: "Ms.", value: 2 },
  { name: "Mrs.", value: 3 },
  { name: "Dr.", value: 4 },
];

const courseTabNames = {
  ENROLLED: "Enrolled",
  ACTIVE: "Active",
  COMPLETED: "Completed",
  REQUESTED: "Requested",
  FAVOURITE: "Favourite",
};
const AssignmentType = {
  MCQ: {
    name: "Multiple Choice Questions",
    value: 1,
  },
  TF: {
    name: "True/False",
    value: 2,
  },
  FITB: {
    name: "Fill-In-The-Blanks",
    value: 3,
  },
  SAQ: {
    name: "Short-Answer-Questions",
    value: 4,
  },
  EQ: {
    name: "Essay-Questions",
    value: 5,
  },
  // OEQ: {
  //   name: "Open-Ended-Questions",
  //   value: 6,
  // },
  MULTIFACETED: {
    name: "Mixed Questions",
    value: 7,
  },
};
/** Lesson generation modes offered by the chat-input menu (next to the mic). */
const GenerationType = {
  STORY: {
    value: "story",
    label: "Story Generation",
    description:
      "Wraps the learning objectives inside a story - students learn through a scenario",
    badge: "New",
  },
  CONTENT: {
    value: "content",
    label: "Content Generation",
    description:
      "Generate a structured textual lesson with a graded assignment and rubric",
  },
};

/** Default generation mode = existing behaviour, so nothing changes until a teacher opts in. */
const DEFAULT_GENERATION_TYPE = GenerationType.STORY.value;

const AssignmentDuration = {
  "10min": {
    name: "10 minute",
    value: "10",
  },
  "30min": {
    name: "30 minutes",
    value: "30",
  },
};

const AssignmentTypeValue = {
  // MCQ -> 1
  "Multiple Choice Questions": 1,
  "Multiple-Choice-Questions": 1,
  "MCQ": 1,

  // TF -> 2
  "True/False": 2,
  "True and False": 2,
  "T/F": 2,

  // FITB -> 3
  "Fill In The Blanks": 3,
  "Fill-In-The-Blanks": 3,
  "FITB": 3,

  // SAQ -> 4
  "Short Answer Questions": 4,
  "Short-Answer Questions": 4,
  "Short-Answer-Questions": 4,
  "SAQ": 4,

  // EQ -> 5
  "Essay Questions": 5,
  "Essay-Questions": 5,
  "EQ": 5,

  // Mixed -> 7
  "Mixed Questions": 7,
  "Mixed-Questions": 7,
};
export {
  genders,
  courseTabNames,
  AssignmentType,
  AssignmentDuration,
  titles, AssignmentTypeValue,
  GenerationType,
  DEFAULT_GENERATION_TYPE,
};
